export const pt = {
    translations: {
        navBar: {
            navBarLogo: '<GabrielDev />',
            aboutMe: 'Sobre Mim',
            projects: 'Projetos',
            contact: 'Contato',
        },
        languageSelector: {
            portuguese: 'Portugues',
            english: 'Ingles',
        },
        wellcomePage: {
            getCv: 'Curriculo',
            contact: 'Contato',
        },
        carer: {
            description: {
                introductionText: 'Sou apaixonado por tecnologia, tive meu primeiro acesso a programação em 2013 apos criar e dar manutenção em servidores de tibia feitos em lua e PHP durante pouco mais de um ano',
                carerDescription: 'Em 2020 consegui minha primeira experiencia profissional onde sigo até hoje, como desenvolvedor fullstack pleno, após ter passado em contato com varias tecnologias, como: PHP, Laravel, Node.js, Python, React, Vue.js, RabbitMQ, dentre outros.'
            },
            carrerTimeLine: {
                butons: {
                    seeMore: 'Ver mais',
                },
                companies: {
                    '123milhas': {
                        role: 'Desenvolvedor Backend Pleno',
                        description: `- Desenvolvimeno e manuenção em aplicação backend feita em laravel + mysql.
- Integração com Gateways de pagamento
- Definição de arquitetura, implemenação de cultura de testes unitarios
- Testes unitarios em aplicações laravel utilizando PHPUnit, Pest
- Jobs de alto desempenho usando sqs
- Integração com ci/cd, pipeline de testes/deploy no k8s`,
                    },
                    objective: {
                        role: 'Desenvolvedor Backend Pleno',
                        description: `- Prestando consultoria ao EBANX
- Integração com Gateways de pagamento
- Desenvolvimento e manutenção da Payment Page EBANX com frontend feito em React, criando testes unitários com Jest e testes de integração com cypress.
- Backend feito em PHP, utilizando DDD como metodologia de desenvolvimento, com testes unitários utilizando PHPUnit.
- CI/CD.`,
                    },
                    logcomex: {
                        role: 'Engenheiro de Software',
                        description: `- Desenvolvimento e manutenção de sistemas com frontend feito em Vue + Nuxt.js e Typescript. 
Backend feito em Laravel + php, e banco de dados pgsql.
- Refatoração de um monólito feito em laravel para uma arquitetura de microserviços, utilizando Rabbitmq + Lumen.
- Criação de lambda functions na aws Feito com python + auroraDB postgre plugado a um SQS e SNS
- Testes unitários no frontend usando Jest.
- Testes unitários para aplicações php usando PHPunit.
- Testes unitários em aplicações python utilizando pytest`,
                    },
                    freelancer: {
                        role: 'Dev freelancer Full-stack',
                        description: `- Desenvolvimento de software
- Criação de um Sistema de gestão 
- Javascript, Node, Vue.js
- Banco de Dados Mysql`,
                    },
                    teknisa: {
                        role: '',
                        description: `- Implantação de novas funcionalidades
- Desenvolvimento de software
- PHP, Javascript, Typescript, Json, Vue
- Banco de Dados Oracle SQL Developer`,
                    }
                },
            }
        },
    }
};
